<template>
  <div>
    <b-row>
      <!-- ป้าย VMS -->
      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="12"
        xs="12"
      >
        <b-row>
          <b-col
            xl="4"
            lg="4"
            md="4"
            sm="12"
            xs="12"
            class="col align-self-center"
          >
            <b-img
              v-if="ntime === 0 & rain === '0'"
              height="140px"
              src="@/assets/images/icons/weather/weather-2.png"
            />
            <b-img
              v-if="ntime === 1 & rain === '0'"
              height="140px"
              src="@/assets/images/icons/weather/cloudy-1.png"
            />
            <b-img
              v-if="rain !== '0'"
              height="140px"
              src="@/assets/images/icons/weather/weather-1.png"
            />
          </b-col>
          <b-col
            xl="8"
            lg="8"
            md="8"
            sm="12"
            xs="12"
            class="mb-1"
          >
            <!-- ระดับน้ำปัจจุบัน -->
            <b-row>
              <b-col
                cols="8"
              >
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 291 257"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H268.2C272.68 0 274.921 0 276.632 0.871948C278.137 1.63893 279.361 2.86278 280.128 4.36808C281 6.07937 281 8.31958 281 12.8V244.2C281 248.68 281 250.921 280.128 252.632C279.361 254.137 278.137 255.361 276.632 256.128C274.921 257 272.68 257 268.2 257H12.8C8.31957 257 6.07937 257 4.36808 256.128C2.86278 255.361 1.63893 254.137 0.871948 252.632C0 250.921 0 248.68 0 244.2V12.8Z"
                    fill="#000A0F"
                    fill-opacity="0.59"
                  />
                  <foreignObject
                    width="100%"
                    height="100%"
                    x="20"
                    y="50"
                  >
                    <div>
                      <svg
                        width="48"
                        height="40"
                        viewBox="0 0 28 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M23.274 8.57189C24.5946 8.87288 25.7583 9.64952 26.5429 10.7537C27.3276 11.8578 27.6785 13.2122 27.5285 14.5585C27.3786 15.9048 26.7383 17.1488 25.7299 18.0532C24.7215 18.9576 23.4155 19.4591 22.061 19.4621H6.89883C5.18971 19.4638 3.54092 18.8303 2.27254 17.6847C1.00415 16.539 0.206673 14.9629 0.0349079 13.2622C-0.136857 11.5616 0.329349 9.85783 1.34302 8.48163C2.35669 7.10544 3.84551 6.15502 5.52046 5.81488V5.67703C5.51959 4.94797 5.71145 4.23164 6.0766 3.60064C6.44175 2.96963 6.9672 2.44638 7.59971 2.08391C8.23222 1.72145 8.94931 1.53265 9.67829 1.53665C10.4073 1.54065 11.1222 1.73731 11.7507 2.1067C12.7179 1.15093 13.9472 0.50396 15.2826 0.247854C16.618 -0.00825284 17.9993 0.13804 19.2514 0.668177C20.5036 1.19831 21.5701 2.08841 22.3157 3.22558C23.0613 4.36275 23.4524 5.69575 23.4394 7.05553C23.4394 7.57936 23.3842 8.07563 23.274 8.57189Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </foreignObject>
                  <foreignObject
                    width="100%"
                    height="100%"
                    x="75"
                    y="50"
                  >
                    <div>
                      <span style="font-size:28px; color: #fff;"> สภาพอากาศ</span>
                    </div>
                  </foreignObject>
                  <foreignObject
                    width="100%"
                    height="100%"
                    x="35"
                    y="150"
                  >
                    <div>
                      <span style="font-size:38px; color: #fff; font-weight: 400;">อุณหภูมิ </span>
                      <span style="font-size:32px; color: #fff;"> {{ Math.round(temp) }} °C</span>
                    </div>
                  </foreignObject>
                </svg>
              </b-col>

              <b-col
                cols="4"
                style="margin-left: -12px;"
              >
                <b-row style="margin-bottom: 7px;">
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 128 96"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H115.2C119.68 0 121.921 0 123.632 0.871948C125.137 1.63893 126.361 2.86278 127.128 4.36808C128 6.07937 128 8.31958 128 12.8V83.2C128 87.6804 128 89.9206 127.128 91.6319C126.361 93.1372 125.137 94.3611 123.632 95.1281C121.921 96 119.68 96 115.2 96H12.8C8.31958 96 6.07937 96 4.36808 95.1281C2.86278 94.3611 1.63893 93.1372 0.871948 91.6319C0 89.9206 0 87.6804 0 83.2V12.8Z"
                      fill="#06703B"
                      fill-opacity="0.35"
                    />
                    <foreignObject
                      width="100%"
                      height="100%"
                      x="15"
                      y="10"
                    >
                      <div>
                        <span style="font-size:18px; color: #fff;"> น้ำฝน</span>
                      </div>
                    </foreignObject>
                    <foreignObject
                      width="100%"
                      height="100%"
                      x="15"
                      y="45"
                    >
                      <div>
                        <span style="font-size:24px; color: #fff; font-weight: 600;">{{ rain }} </span>
                        <span style="font-size:22px; color: #fff;"> มม./นาที</span>
                      </div>
                    </foreignObject>
                  </svg>
                </b-row>

                <b-row>
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 128 95"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H115.2C119.68 0 121.921 0 123.632 0.871948C125.137 1.63893 126.361 2.86278 127.128 4.36808C128 6.07937 128 8.31958 128 12.8V82.2C128 86.6804 128 88.9206 127.128 90.6319C126.361 92.1372 125.137 93.3611 123.632 94.1281C121.921 95 119.68 95 115.2 95H12.8C8.31958 95 6.07937 95 4.36808 94.1281C2.86278 93.3611 1.63893 92.1372 0.871948 90.6319C0 88.9206 0 86.6804 0 82.2V12.8Z"
                      fill="#FB0000"
                      fill-opacity="0.35"
                    />
                    <foreignObject
                      width="100%"
                      height="100%"
                      x="15"
                      y="10"
                    >
                      <div>
                        <span style="font-size:18px; color: #fff;"> ความเร็วลม</span>
                      </div>
                    </foreignObject>
                    <foreignObject
                      width="100%"
                      height="100%"
                      x="5"
                      y="45"
                    >
                      <div>
                        <span style="font-size:22px; color: #fff; font-weight: 600;">{{ wind }} </span>
                        <span style="font-size:22px; color: #fff;"> กม./ชม.</span>
                      </div>
                    </foreignObject>
                  </svg>
                </b-row>
              </b-col>
            </b-row>
            <!-- สถานะเรือ -->
            <b-row
              cols="12"
              class="mt-1"
            >
              <b-col
                cols="12"
              >
                <!-- ดี -->
                <svg
                  v-if="pm25 <= 50"
                  width="100%"
                  height="100%"
                  viewBox="0 0 405 109"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_228_36)">
                    <rect
                      width="405"
                      height="109"
                      rx="4"
                      fill="url(#paint0_linear_228_36)"
                      fill-opacity="0.74"
                    />
                  </g>
                  <path
                    d="M39 75C50.0457 75 59 66.0457 59 55C59 43.9543 50.0457 35 39 35C27.9543 35 19 43.9543 19 55C19 66.0457 27.9543 75 39 75Z"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M31 49.1V48.9M47 49.1V48.9"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M47 59C46 62 43.42 65 39 65C34.58 65 32 62 31 59"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <filter
                      id="filter0_b_228_36"
                      x="-36"
                      y="-36"
                      width="477"
                      height="181"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                      />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="18"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_228_36"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_228_36"
                        result="shape"
                      />
                    </filter>
                    <linearGradient
                      id="paint0_linear_228_36"
                      x1="202.5"
                      y1="0"
                      x2="202.5"
                      y2="109"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#63FF55" />
                      <stop
                        offset="1"
                        stop-color="#08B72F"
                      />
                    </linearGradient>
                  </defs>

                  <foreignObject
                    width="100%"
                    height="100%"
                    x="75"
                    y="25"
                  >
                    <div>
                      <span style="font-size:24px; color: #fff;">คุณภาพอากาศ</span>
                    </div>
                    <span style="font-size:20px; color: #fff;"> สถานะ: คุณภาพดี</span>
                  </foreignObject>
                  <foreignObject
                    width="100%"
                    height="100%"
                    x="260"
                    y="15"
                  >
                    <div>
                      <span style="font-size:36px; color: #fff;">{{ pm25 }} AQI</span>
                    </div>
                  </foreignObject>
                </svg>
                <!-- ปานกลาง -->
                <svg
                  v-if="pm25 >= 51 && pm25 <= 100"
                  width="100%"
                  height="100%"
                  viewBox="0 0 405 109"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_228_37)">
                    <rect
                      width="405"
                      height="109"
                      rx="4"
                      fill="url(#paint0_linear_228_37)"
                      fill-opacity="0.74"
                    />
                  </g>
                  <path
                    d="M39 75C50.0457 75 59 66.0457 59 55C59 43.9543 50.0457 35 39 35C27.9543 35 19 43.9543 19 55C19 66.0457 27.9543 75 39 75Z"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M44.6 49.4V47.8M33.4 49.4V47.8M31.8 62.2H46.2"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <filter
                      id="filter0_b_228_37"
                      x="-36"
                      y="-36"
                      width="477"
                      height="181"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                      />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="18"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_228_37"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_228_37"
                        result="shape"
                      />
                    </filter>
                    <linearGradient
                      id="paint0_linear_228_37"
                      x1="202.5"
                      y1="0"
                      x2="202.5"
                      y2="109"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFD755" />
                      <stop
                        offset="1"
                        stop-color="#FFC300"
                      />
                    </linearGradient>
                  </defs>

                  <foreignObject
                    width="100%"
                    height="100%"
                    x="75"
                    y="25"
                  >
                    <div>
                      <span style="font-size:24px; color: #fff;">คุณภาพอากาศ</span>
                    </div>
                    <span style="font-size:20px; color: #fff;"> สถานะ: คุณภาพปานกลาง</span>
                  </foreignObject>
                  <foreignObject
                    width="100%"
                    height="100%"
                    x="260"
                    y="15"
                  >
                    <div>
                      <span style="font-size:36px; color: #fff;">{{ pm25 }} AQI</span>
                    </div>
                  </foreignObject>
                </svg>
                <!-- เริ่มมีผลต่อสุขภาพ -->
                <svg
                  v-if="pm25 >= 101 && pm25 <= 150"
                  width="100%"
                  height="100%"
                  viewBox="0 0 405 109"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_228_38)">
                    <rect
                      width="405"
                      height="109"
                      rx="4"
                      fill="url(#paint0_linear_228_38)"
                      fill-opacity="0.74"
                    />
                  </g>
                  <path
                    d="M39 75C50.0457 75 59 66.0457 59 55C59 43.9543 50.0457 35 39 35C27.9543 35 19 43.9543 19 55C19 66.0457 27.9543 75 39 75Z"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M44.6 49.4V47.8M33.4 49.4V47.8M31.8 63.8C31.8 63.8 33.4 60.6 39 60.6C44.6 60.6 46.2 63.8 46.2 63.8"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <filter
                      id="filter0_b_228_38"
                      x="-4"
                      y="-4"
                      width="413"
                      height="117"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                      />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="2"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_228_38"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_228_38"
                        result="shape"
                      />
                    </filter>
                    <linearGradient
                      id="paint0_linear_228_38"
                      x1="202.5"
                      y1="0"
                      x2="202.5"
                      y2="109"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FF9255" />
                      <stop
                        offset="1"
                        stop-color="#FF4D00"
                      />
                    </linearGradient>
                  </defs>

                  <foreignObject
                    width="100%"
                    height="100%"
                    x="75"
                    y="25"
                  >
                    <div>
                      <span style="font-size:24px; color: #fff;">คุณภาพอากาศ</span>
                    </div>
                    <span style="font-size:20px; color: #fff;"> สถานะ: คุณภาพเริ่มมีผลต่อสุขภาพ</span>
                  </foreignObject>
                  <foreignObject
                    width="100%"
                    height="100%"
                    x="260"
                    y="15"
                  >
                    <div>
                      <span style="font-size:36px; color: #fff;">{{ pm25 }} AQI</span>
                    </div>
                  </foreignObject>
                </svg>
                <!-- มีผลต่อสุขภาพ -->
                <svg
                  v-if="pm25 >= 151 && pm25 <= 200"
                  width="100%"
                  height="100%"
                  viewBox="0 0 405 109"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_228_47)">
                    <rect
                      width="405"
                      height="109"
                      rx="4"
                      fill="url(#paint0_linear_228_47)"
                      fill-opacity="0.74"
                    />
                  </g>
                  <path
                    d="M39 75C50.046 75 59 66.046 59 55C59 43.954 50.046 35 39 35C27.954 35 19 43.954 19 55C19 66.046 27.954 75 39 75Z"
                    stroke="white"
                    stroke-width="4"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M47 48L44 51L47 54M31 48L34 51L31 54M39 60C44 60 46 64 46 64H32C32 64 34 60 39 60Z"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <filter
                      id="filter0_b_228_47"
                      x="-4"
                      y="-4"
                      width="413"
                      height="117"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                      />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="2"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_228_47"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_228_47"
                        result="shape"
                      />
                    </filter>
                    <linearGradient
                      id="paint0_linear_228_47"
                      x1="202.5"
                      y1="0"
                      x2="202.5"
                      y2="109"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FF5555" />
                      <stop
                        offset="1"
                        stop-color="#FF0000"
                      />
                    </linearGradient>
                  </defs>

                  <foreignObject
                    width="100%"
                    height="100%"
                    x="75"
                    y="25"
                  >
                    <div>
                      <span style="font-size:24px; color: #fff;">คุณภาพอากาศ</span>
                    </div>
                    <span style="font-size:20px; color: #fff;"> สถานะ: คุณภาพมีผลต่อสุขภาพ</span>
                  </foreignObject>
                  <foreignObject
                    width="100%"
                    height="100%"
                    x="260"
                    y="15"
                  >
                    <div>
                      <span style="font-size:36px; color: #fff;">{{ pm25 }} AQI</span>
                    </div>
                  </foreignObject>
                </svg>
                <!-- มีผลต่อสุขภาพมาก -->
                <svg
                  v-if="pm25 >= 201 && pm25 <= 300"
                  width="100%"
                  height="100%"
                  viewBox="0 0 405 109"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_b_228_35)">
                    <rect
                      width="405"
                      height="109"
                      rx="4"
                      fill="url(#paint0_linear_228_35)"
                      fill-opacity="0.74"
                    />
                  </g>
                  <path
                    d="M39 75C50.046 75 59 66.046 59 55C59 43.954 50.046 35 39 35C27.954 35 19 43.954 19 55C19 66.046 27.954 75 39 75Z"
                    stroke="white"
                    stroke-width="4"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M48 56L44 54M33 54L29 56M46 66C46 66 44 62 39 62C34 62 32 66 32 66"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <filter
                      id="filter0_b_228_35"
                      x="-4"
                      y="-4"
                      width="413"
                      height="117"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix"
                      />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="2"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_228_35"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_228_35"
                        result="shape"
                      />
                    </filter>
                    <linearGradient
                      id="paint0_linear_228_35"
                      x1="202.5"
                      y1="0"
                      x2="202.5"
                      y2="109"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#F155FF" />
                      <stop
                        offset="1"
                        stop-color="#CC00FF"
                      />
                    </linearGradient>
                  </defs>

                  <foreignObject
                    width="100%"
                    height="100%"
                    x="75"
                    y="25"
                  >
                    <div>
                      <span style="font-size:24px; color: #fff;">คุณภาพอากาศ</span>
                    </div>
                    <span style="font-size:20px; color: #fff;"> สถานะ: คุณภาพมีผลต่อสุขภาพมาก</span>
                  </foreignObject>
                  <foreignObject
                    width="100%"
                    height="100%"
                    x="260"
                    y="15"
                  >
                    <div>
                      <span style="font-size:36px; color: #fff;">{{ pm25 }} AQI</span>
                    </div>
                  </foreignObject>
                </svg>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <!-- กราฟอุณหภูมิ (วัน) -->
      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="12"
        xs="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div style="font-size: 20px;">
            <b-img
              class="mr-1"
              height="30"
              src="@/assets/images/icons/chartr.svg"
            />
            <strong>กราฟอุณหภูมิ (วัน)</strong>
            <!-- <em>word wrap</em> -->
          </div>
          <b-row>
            <b-col
              cols="12"
            >
              <div class="mt-2">
                <app-echar-line
                  :option-data="option"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>

    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BCard,
  // BButton, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import AppEcharLine from '@/views/vms/detail/garaphLineDB/AppEchartLineDB.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    AppEcharLine,
    // BButton,
    // BBadge,
  },
  data() {
    return {
      option: {
        xAxisData: [],
        series: [
          {
            name: 'อุณหภูมิ',
            type: 'line',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00B058' },
                { offset: 1, color: 'rgba(4, 22, 22, 0.1)' },
              ]),
            },
            color: '#00B058',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
          {
            name: 'PM 2.5',
            type: 'line',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FDFF01' },
                { offset: 1, color: 'rgba(4, 22, 22, 0.1)' },
              ]),
            },
            color: '#FDFF01',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      items: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      temp: '',
      rain: '',
      pm25: '',
      wind: '',
      ntime: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getChartTemp()
    this.getVideo()
    this.interval = setInterval(() => {
      this.getVideo()
    }, 300000)
  },
  methods: {
    getChartTemp() {
      axios
        .post('/graphVMSTemp', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisData = []
          this.xAxisData[0] = response.data
          this.xAxisData[0][0].forEach(value => {
            this.option.xAxisData.push(value.Period_Name)
            this.option.series[0].data.push(value.value)
          })
          this.xAxisData[0][1].forEach(value => {
            this.option.series[1].data.push(value.value)
          })
          // this.xAxisData = []
          // // eslint-disable-next-line prefer-destructuring
          // this.xAxisData = response.data[0]
          // this.xAxisData.forEach(value => {
          //   this.option.xAxisData.push(value.Period_Name)
          //   this.option.series[0].data.push(value.value)
          // })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getVideo() {
      axios
        .post('/getWeatherVMS', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.temp = response.data[1].value
          this.rain = response.data[2].value
          this.wind = response.data[3].value
          this.pm25 = response.data[0].value
          // this.ntime = response.data[0].ntime.toString()
          const time = new Date()
          const time1 = time.getHours()
          console.log(time1)
          if (time1 >= 0 && time1 < 6) {
            this.ntime = 0
          }
          if (time1 >= 6 && time1 < 18) {
            this.ntime = 1
          }
          if (time1 >= 18 && time1 <= 23) {
            this.ntime = 0
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
.center{
 margin: 0 auto;
 width: 300px;
 display: block;
}
  </style>
